import { Record } from "immutable"

export default Record({
  average: 0,
  max: 0,
  min: 0,
  results: 0,
})
